import { render, staticRenderFns } from "./overdueStatus.vue?vue&type=template&id=0bcd85ce&scoped=true&"
import script from "./overdueStatus.vue?vue&type=script&lang=js&"
export * from "./overdueStatus.vue?vue&type=script&lang=js&"
import style0 from "./overdueStatus.vue?vue&type=style&index=0&id=0bcd85ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcd85ce",
  null
  
)

export default component.exports